import React from 'react';
import { printables } from 'Settings/printables';

import Button from 'Components/Button';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';
import styles from './GamePrintableFeatured.scss';

const GamePrintableFeatured = ({ id }) => {
  const printable = printables[id];
  const graphic = require(`./Worksheet_Thumbnail.png`);
  const downloadUri = `/assets/printables/${printable.printableFileName}`;

  return (
    <a
      className="GamePrintableFeatured is-hoverable-parent"
      href={downloadUri}
      target="_blank"
    >
      <ConnectedFormattedImage
        className="GamePrintableFeatured__graphic"
        src={graphic}
        altId="game_handbook.featured_icon_alt"
      />
      <div className="GamePrintableFeatured__copy">
        <div className="GamePrintableFeatured__title">
          <ConnectedFormattedMessage id={`printables.${id}.title`} />
        </div>
        <div className="GamePrintableFeatured__grades">
          <ConnectedFormattedMessage id="game_printable.grade_prefix" />{' '}
          <ConnectedFormattedMessage id={`printables.${id}.grades`} />
        </div>
        <p className="GamePrintableFeatured__description">
          <ConnectedFormattedMessage id={`printables.${id}.description`} />
        </p>
        <Button
          clickHandler={() => null}
          buttonType="tertiary-outline"
          ctaIcon="caret"
          label={
            <ConnectedFormattedMessage id="game_printable.view_button_label" />
          }
        />
      </div>
    </a>
  );
};

export default GamePrintableFeatured;
